<template>
  <g ref="yAxis" v-bind:transform="'translate(' + (axisWidth || 0) + ',0)'"></g>
</template>

<script>
import * as d3 from 'd3'

export default {
  name: 'yAxis',
  props: ['scale', 'format', 'axisWidth', 'orient', 'tickValues'],
  mounted: function () {
    this.redraw()
  },
  methods: {
    redraw: function () {
      let s = d3.select(this.$refs.yAxis)
      s.selectAll('g').remove()
      s.call(this.axis)
    },
  },
  computed: {
    axis: function () {
      let out
      if (this.orient === 'right') {
        out = d3.axisRight(this.scale)
      } else {
        out = d3.axisLeft(this.scale)
      }
      out = out.ticks(10).tickFormat(this.format)
      if (this.tickValues) {
        out.tickValues(this.tickValues)
      }
      return out
    },
  },
  watch: {
    scale: function () {
      this.redraw()
    },
    format: function () {
      this.redraw()
    },
  },
}
</script>

<style scoped>

</style>
